import { Box } from '@mui/material';
import React from 'react';
import { GetMedicineDto } from 'woofwoof-api';
import MedicinePreparationChip from './MedicinePreparationChip';

interface RegistryMedicineOptionContentProps {
  medicine: GetMedicineDto;
}

/** A registry medicine: the row the picker always had. */
export default function RegistryMedicineOptionContent({
  medicine,
}: RegistryMedicineOptionContentProps): React.ReactElement {
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
        <Box sx={{ fontWeight: 500, flex: 1 }}>{medicine.productName}</Box>
        {medicine.preparationType && (
          <MedicinePreparationChip preparationType={medicine.preparationType} />
        )}
      </Box>
      {medicine.commonName && (
        <Box sx={{ fontSize: '0.875rem', color: 'text.secondary' }}>
          {medicine.commonName}
        </Box>
      )}
      {medicine.strength && (
        <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
          {medicine.strength}
        </Box>
      )}
    </Box>
  );
}
